// extracted by mini-css-extract-plugin
module.exports = {"card":"PasswordRecovery_card__3rRed","description":"PasswordRecovery_description__dBacm"};